<template>
  <div class="formRequoteWrapper">
    <p>Indícanos el motivo de la recotización.</p>
    <section class="radioWrapper">
        <b-field :key="reason.id" v-for="reason in listReasons" >
            <b-radio v-model="radio"
                :native-value="reason.id"
                type="is-success">
                {{reason.description}}
            </b-radio>
        </b-field>
    </section>
    <p>Coméntanos sobre el motivo de rechazo seleccionado <span v-show="textRequired()">(*)</span> </p>
    <section class="wrapperSection">
        <b-field>
            <b-input v-model="text" maxlength="500" type="textarea" :required="textRequired()"></b-input>
        </b-field>
        <div>
          <label class="c-form__form-label" for="comment">ADJUNTAR ARCHIVO</label>
          <input-file
            class="dropFiles"
            :dropFiles="dropFiles"
          />
          <label class="labelInputFile" for="comment">Máximo puedes adjuntar 3 documentos.</label>
        </div>
    </section>
    <b-button @click="submit" class="buttonSubmit" type="primary" :disabled="disabled || fileIsLoading">Enviar</b-button>
  </div>
</template>

<script>
import { updateProductData } from "@/services/services.js";
import inputFile from "../components/fields/InputFileComment.vue"
import store from "@/store"

export default {
  name:"ReasonsRequote",
  components: {
    inputFile,
  },
  props: {
    listReasons: Array,
    action: String,
    quotationId: String,
    dropFiles: Array,
  },
  data() {
      return {
          radio: null,
          text: ""
      }
  },
  computed: {
    fileIsLoading() {
      return store.state.fileCommentIsLoading
      },
    disabled() {
      if ( this.textRequired() ){
        if( this.radio && this.text) {
          return false
        }
      } else if ( this.radio ){
        return false
      }
      return true
    },
  },
  methods: {
    textRequired() {
      if ( this.radio === this.listReasons[this.listReasons.length-1].id){
        return true
      }
      return false
    },
    submit() {
      let attachmentIds = [];
      store.state.uploadFiles.map((file) => attachmentIds.push(file.id));
        let data = {
          'action': this.action,
          'reason_id': this.radio,
          'attachment_ids': attachmentIds,
      }
      if( this.radio === this.listReasons[this.listReasons.length-1].id) {
        console.log("añadio texto", this.listReasons[this.listReasons.length-1])
        data['text'] = this.text
      }else if (this.text) {
        data['text'] = this.text
      }

      const loader = this.$buefy.loading.open();
        updateProductData(this.quotationId, data).then((response) => {
          if (response.status == 200) {
              loader.close()
              this.$router.push("/quotation/post/confirm")
          }
        }).catch((error) => {
            loader.close()
            this.isLoading = false;
        });
    }
  }
}
</script>

<style lang="scss">
.formRequoteWrapper {
  margin-left: 30px;
}
.radioWrapper {
  margin-top: 20px;
}
.wrapperSection {
  margin-bottom: 74px;
}
.dropFiles {
  margin-top: 12px;
  .field {
    label{
      width: 100%;
      div {
        width: 100%;
      }
    }
  }
}
.labelInputFile {
  color: #717171;
}
/* .buttonSubmit {
  width: 256px;
  background: #FF6D46;
  border-radius: 4px;
} */
</style>
